import { showModal, updateModal, hideModal } from '@lib/redux/actions/modals';

const modalsReducer = (state = [], { type, payload }) => {
  switch (type) {
    case showModal.type: {
      const { modalType, props, config } = payload;
      return [
        // only allow one of the same modal to be shown at the same time
        ...state.filter((modal) => modal.modalType !== modalType),
        {
          modalType,
          props,
          config,
        },
      ];
    }
    case updateModal.type: {
      const { modalType, props, config } = payload;
      return state.map((modal) => {
        if (modalType !== modal.modalType) return modal;
        return {
          modalType,
          props: {
            ...modal.props,
            ...props,
          },
          config: {
            ...modal.config,
            ...config,
          },
        };
      });
    }
    case hideModal.type: {
      return state.filter((modal) => modal.modalType !== payload);
    }
    default:
      return state;
  }
};

export default modalsReducer;
